export default "/images/daymaker.jpg";